import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardContext, UserContext, ToasterContext } from '../../../context';
import { DashService } from '../../../services';
import { default as t } from '../../../utils/i18n';
import { Table, Checkbox } from 'rsuite';
import { Dropdown, Button, SearchBar, AppTooltip, HelpPdfDownload } from '../../atoms';
import './import-campaign-container.scss';
import { createPostTrackUsagePayload, UsageIdentifierFlow } from '../../../utils/misc';
import { postTrackUsageAPI } from '../../../services/dash.service';

const ImportCampaignContainer = props => {
  const history = useHistory();
  const { dashData } = useContext(DashboardContext);
  const { user, setUser } = useContext(UserContext);
  const { message, setMessage } = useContext(ToasterContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const { Column, HeaderCell, Cell } = Table;
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedVals, setSelectedVals] = useState([
    { id: '0', value: t('report.client.reporting.select.campaign') },
  ]);
  const [searchItem, setSearchItem] = useState('');
  const [show, showstyle] = useState('');
  const [filteredList, setfilteredList] = useState([]);
  const [businessManagers, setBusinessManagers] = useState([]);
  const [selectedBM, setSelectedBM] = useState('');
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAdAccount, setSelectedAdAccount] = useState('');
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [loading, setLoading] = useState(false);
  const [importSelected, setImportSelected] = useState([]);

  const [disabledButton, setDisabledButton] = useState(true);

  const [currency, setCurrency] = useState('');
  const [data, setData] = useState([]);
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  let checked = false;
  let indeterminate = false;

  const handleBackClick = e => {
    props.handleBackClick(e);
  };
  useEffect(() => {
    setfilteredList(data);
  }, []);

  useEffect(() => {
    getBusinessManager();

    document.body.style.overflow = 'auto';
  }, []);
  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }} className={rowData.is_imported ? 'disabled' : null}>
        <Checkbox
          value={rowData[dataKey]}
          inline
          onChange={onChange}
          checked={checkedKeys.some(item => item === rowData[dataKey])}
        />
      </div>
    </Cell>
  );

  if (checkedKeys.length === data?.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < data.length) {
    indeterminate = true;
  }

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
    return dd + '-' + mm + '-' + yyyy;
  };

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormat(startTime) + ' to ' + updateDateFormat(stopTime);
    } else {
      return updateDateFormat(startTime) + ' ' + 'onwards';
    }
  };

  const deleteItem = (id, list) => {
    const templist = [...list];
    const updateList = templist.filter(item => item.id !== id);
    const unchecked = checkedKeys.filter(keys => keys !== id);
    setSelectedVals(updateList);
    setCheckedKeys(unchecked);
    setImportSelected(unchecked);
    if (updateList.length === 0) {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setImportSelected([]);
      setDisabledButton(true);
    }
  };

  const addItems = keys => {
    let newList = data.filter(item => keys.includes(item.id));
    let checkedItem = newList
      .filter(x => x.is_imported === false)
      .map(item => {
        return { id: item.id, value: item.name };
      });

    let checkedList = [];
    checkedList.push(checkedItem);
    setSelectedVals(checkedList[0]);
  };

  const handleCheckAll = (value, checked) => {
    let keys = checked ? data.map(item => item.id) : [];
    let tobeimported = data.filter(x => x.is_imported === false).map(y => y.id);
    if (!checked) {
      let notToUncheck = data.filter(x => x.is_imported === true).map(y => y.id);
      setCheckedKeys(notToUncheck);
    } else {
      setCheckedKeys(keys);
    }
    addItems(keys);
    keys = keys.filter(item => tobeimported.includes(item));
    setImportSelected(keys);
    if (keys.length > 0) {
      setDisabledButton(false);
    } else {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setDisabledButton(true);
    }
  };

  const handleCheck = (value, checked) => {
    let keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
    setCheckedKeys(keys);
    addItems(keys);
    let tobeimported = data.filter(x => x.is_imported === false).map(y => y.id);
    keys = keys.filter(item => tobeimported.includes(item));
    setImportSelected(keys);
    if (keys.length > 0) {
      setDisabledButton(false);
    } else {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setDisabledButton(true);
    }
  };

  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      setfilteredList(data);
    } else {
      showstyle('show');
      setSearchItem(keyword);
      // let res = data.filter(item => item.name.toLowerCase().includes(keyword.toLowerCase()));

      let res = data.filter(function (obj) {
        return (
          obj.name.toLowerCase().includes(keyword.toLowerCase()) ||
          obj.id.includes(keyword) ||
          obj.objective.toLowerCase().includes(keyword.toLowerCase())
        );
      });
      setfilteredList(res);
    }
  };

  async function getBusinessManager() {
    try {
      const bmResponse = await DashService.bmList(userAccessToken, username);
      let businessManagersList = bmResponse.data?.data?.map(businessMs => ({
        value: businessMs.id,
        label: businessMs.name,
      }));
      setBusinessManagers(businessManagersList);
      setSelectedBM(businessManagersList[0]);
      getAdAccounts(businessManagersList[0].value);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getAdAccounts(selectedOption) {
    try {
      const adAcResponse = await DashService.adAccountList(
        userAccessToken,
        username,
        selectedOption
      );
      let adAccountList = adAcResponse.data?.data?.map(adAccounts => ({
        value: adAccounts.id,
        label: adAccounts.name,
      }));
      setAdAccounts(adAccountList);
      setSelectedAdAccount('');
      //getCampaigns(adAccountList[0].value);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getCampaigns(selectedOption) {
    setData([]);
    setfilteredList([]);
    try {
      const campaignsResponse = await DashService.campaignsList(
        userAccessToken,
        username,
        selectedOption
      );
      let currency = '(' + campaignsResponse.data?.data?.campaigns[0]?.currency + ')';
      let checkedKeys = [];
      let campaignsList = campaignsResponse.data?.data?.campaigns?.map(campaignsResponse => ({
        id: campaignsResponse?.id,
        name: campaignsResponse?.name,
        date: getDateRange(campaignsResponse.start_time, campaignsResponse.stop_time),
        is_imported: campaignsResponse?.is_imported,
        budget:
          campaignsResponse?.budget === 'Not Set'
            ? campaignsResponse?.budget
            : nFormatter(campaignsResponse?.budget, 1) +
              '(' +
              capitalizeFirstLetter(campaignsResponse?.budget_mode) +
              ')',
        objective: campaignsResponse?.objective,
        start_date: campaignsResponse.start_time,
      }));
      checkedKeys = campaignsList
        .filter(x => {
          return x.is_imported === true;
        })
        .map(x => x.id);
      setCurrency(currency);
      setCheckedKeys(checkedKeys);
      setData(campaignsList);
      setfilteredList(campaignsList);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }
  const handleOnSelectBM = selectedOption => {
    // setDropdownDisabledButton(false);
    setSelectedBM(selectedOption);
    // setisAdAccountDisabled(true);
    getAdAccounts(selectedOption.value);
    setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
    setImportSelected([]);
    setDisabledButton(true);
  };

  const handleOnSelectAdAccount = selectedOption => {
    setSelectedAdAccount(selectedOption);
    getCampaigns(selectedOption.value);
    setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
    setImportSelected([]);
    setDisabledButton(true);

    setUser(prevUserState => ({
      ...prevUserState,
      dropdowns: {
        adaccount: selectedOption,
        businessManager: selectedBM,
      },
    }));
  };

  const getData = () => {
    if (sortColumn && sortType) {
      return filteredList.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        // if (typeof x === 'string') {
        //   x = x.charCodeAt();
        // }
        // if (typeof y === 'string') {
        //   y = y.charCodeAt();
        // }
        if (sortColumn === 'date') {
          const initialDate = new Date(a.start_date);
          const nextDate = new Date(b.start_date);
          return sortType === 'asc' ? initialDate - nextDate : nextDate - initialDate;
        } else {
          return sortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
        }
      });
    }
    return filteredList;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const callTrackUsageAPI = () => {
    const selectedAdAccountId = [selectedAdAccount.value] || [];
    const localStorageUserObj = localStorage.getItem('user');
    const { usageAPIPayload, updatedLocalStorageUserValue } = createPostTrackUsagePayload(
      selectedAdAccountId,
      JSON.parse(localStorageUserObj),
      UsageIdentifierFlow.AD_ACCOUNT
    );

    if (usageAPIPayload.ids.length) {
      postTrackUsageAPI(userAccessToken, username, {
        ...usageAPIPayload,
        userFlow: `import-campaign`,
      });
    }
    localStorage.setItem('user', JSON.stringify(updatedLocalStorageUserValue));
    setUser(updatedLocalStorageUserValue);
  };

  async function handleOnImportCampaigns() {
    try {
      let importSelectedResponse;
      let diff = -1;
      let data = {
        accountId: selectedAdAccount.value,
        campaigns: importSelected,
      };
      callTrackUsageAPI();
      importSelectedResponse = await DashService.importSelected(userAccessToken, username, data);
      diff = importSelected?.length - importSelectedResponse?.data?.data?.importSuccessfull?.length;

      if (diff === 0) {
        setMessage({ message: t('import.success'), isError: false });
        history.push('/optimization');
      } else if (diff > 0 && !importSelected.length) {
        let msg = `Only ${diff} out of your ${importSelected?.length} campaigns could be imported due to a server error. Please retry again later.`;
        setMessage({ message: msg, isError: true });
        history.push('/optimization');
      } else {
        setMessage({ message: t('import.server.error'), isError: true });
        history.push('/optimization');
      }
    } catch (error) {
      setMessage({ message: t('import.server.error'), isError: true });
      history.push('/optimization');
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const nFormatter = (num, digits) => {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
    ];

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
      .slice()
      .reverse()
      .find(item => {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
  };

  const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Table.Cell
        {...props}
        title={rowData[dataKey]}
        className={rowData.is_imported ? 'disabled' : null}
      >
        {rowData[dataKey]}
      </Table.Cell>
    );
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };

  return (
    <section>
      <div className="import-campaigns-details">
        <div className="heading-btn-container">
          <div className="header-holder">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('perf.back.cta')}
            </button>
          </div>
          <HelpPdfDownload />
        </div>
        <div className="import-campaigns-container-details">
          <div className="topContainer">
            <h3>{t('import.campaign.heading')}</h3>
            <span>{t('import.campaign.subheading')}</span>
            <br></br>
            <span>{t('import.campaign.subheading2')}</span>
          </div>
          <div className="import-select-container">
            <div className="import-left">
              <Dropdown
                heading={t('import.campaign.selectBuissnessManger')}
                placeholder={t('import.campaign.selectBuissnessManger')}
                value={selectedBM}
                options={businessManagers}
                tooltipIndicator={true}
                onSelect={handleOnSelectBM}
                tooltipId={t('import-business-manager')}
                infoData={t('import.campaign.businessManager')}
              />
            </div>
            <div className="action-button">
              <Dropdown
                heading={t('import.campaign.selectadaccount')}
                placeholder={t('search.for.adaccount')}
                value={selectedAdAccount}
                options={adAccounts}
                tooltipIndicator={true}
                onSelect={handleOnSelectAdAccount}
                tooltipId={t('import-ad-account')}
                infoData={t('import.campaign.adAccount')}
                searchIndicator={true}
              />
            </div>
          </div>

          <div className="search-section-container search_align_end">
            <h3>{t('import.campaign.selectCampaign')}</h3>

            <div className="search-field">
              <i className="eva eva-search-outline search-icon"></i>
              <input
                type="text"
                name="search"
                placeholder={t('import.search.campaign')}
                onChange={e => filterHandler(e.target.value, e)}
                value={searchItem}
                autoComplete="off"
              />
              <button
                type="button"
                className={`clear-btn ${show}`}
                onClick={e => filterHandler('')}
              >
                <i className="eva eva-close-outline clear-icon"></i>
              </button>
            </div>
          </div>
          <div className="list-scroll-container">
            <div className="list-scroll">
              <div className="selected-list">
                {selectedVals?.map(item => {
                  return (
                    <div
                      className="selected-item"
                      key={item.id}
                      onClick={() => deleteItem(item.id, selectedVals)}
                    >
                      <span
                        className={
                          selectedVals[0].value === t('report.client.reporting.select.campaign')
                            ? 'selected-value selected-empty-value'
                            : 'selected-value'
                        }
                        title={item?.value}
                      >
                        {item.value?.length > 0 ? item?.value : item?.value}
                      </span>
                      {selectedVals[0].value === t('report.client.reporting.select.campaign') ? (
                        ''
                      ) : (
                        <span className="cross">
                          <i className="eva eva-close-outline clear-icon"></i>
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="import-campaign">
            <Table
              virtualized
              height={400}
              data={getData()}
              sortColumn={sortColumn}
              sortType={sortType}
              onSortColumn={handleSortColumn}
              loading={loading}
            >
              <Column width={50} fixed align="center">
                <HeaderCell style={{ padding: 0 }}>
                  <div style={{ lineHeight: '40px' }}>
                    <Checkbox
                      inline
                      checked={checked}
                      indeterminate={indeterminate}
                      onChange={handleCheckAll}
                      //  disabled={indeterminate ? indeterminate : checkedKeys.length === data.length }
                    />
                  </div>
                </HeaderCell>
                <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
              </Column>
              <Column width={getWidth(5)} fixed sortable>
                <HeaderCell>
                  {t('import.campaign.name')}
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('import.campaign.list')}
                    data-for="tool-tip1"
                  ></i>
                  <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip1"
                    place="bottom"
                  />
                </HeaderCell>
                <TableCell dataKey="name" />
              </Column>

              <Column width={getWidth(5)} fixed sortable>
                <HeaderCell>
                  {t('import.campaign.id')}
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('import.campaign.campaignName')}
                    data-for="tool-tip"
                  ></i>
                  <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip" place="bottom" />
                </HeaderCell>
                <TableCell dataKey="id" />
              </Column>

              <Column width={getWidth(5)} fixed sortable>
                <HeaderCell>
                  {t('create.report.date.heading')}
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('import.campaign.date')}
                    data-for="tool-tip"
                    style={{ marginLeft: '7rem' }}
                  ></i>
                  <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip" place="bottom" />
                </HeaderCell>
                <TableCell dataKey="date" />
              </Column>

              <Column width={getWidth(6)} fixed sortable>
                <HeaderCell>
                  {t('perf.budget')}
                  {currency && <span>{currency}</span>}
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('import.campaign.budget')}
                    data-for="tool-tip"
                    style={{ marginLeft: '7rem' }}
                  ></i>
                  <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip" place="bottom" />
                </HeaderCell>
                <TableCell dataKey="budget" />
              </Column>

              <Column width={getWidth(6)} fixed sortable>
                <HeaderCell>
                  {t('perf.objective')}
                  <i
                    className="eva eva-info-outline"
                    data-tip={t('import.campaign.objective')}
                    data-for="tool-tip"
                    style={{ marginLeft: '8rem' }}
                  ></i>
                  <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip" place="bottom" />
                </HeaderCell>
                <TableCell dataKey="objective" />
              </Column>
            </Table>
          </div>
          <div className="import-button">
            <div className="dsh-details-container--actions--reset">
              <Button
                label={
                  t('import.campaign.button.viewadaccounts') +
                  '(' +
                  `${importSelected.length}` +
                  ')'
                }
                handleClick={() => handleOnImportCampaigns()}
                disabled={disabledButton}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportCampaignContainer;
